import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import { css } from 'styled-components';

export const CustomDashedBorderCss = css<{ isActive: boolean; borderRadius: number }>`
  background-image: ${({ borderRadius, isActive, theme }) => {
    const strokeColor = isActive
      ? colors.wolt100
      : cssThemedValue({ light: colors.pepper20, dark: colors.salt24 })({ theme });

    return `url(\"data:image/svg+xml;charset=utf8,
    <svg xmlns='http://www.w3.org/2000/svg' height='100%' width='100%'>
      <rect
        width='100%'
        height='100%'
        fill='none'
        rx='${borderRadius}'
        ry='${borderRadius}'
        stroke='${strokeColor}'
        stroke-width='4'
        stroke-dasharray='8, 5'
        stroke-dashoffset='0'
        stroke-linecap='butt'
      />
    </svg>
  \")`;
  }};
`;
